export default "__VITE_ASSET__CFRF4SNL__"